import { css } from '@emotion/react';
import React, { ReactElement } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';

const styles = css`
	display: flex;
	align-items: center;
	justify-content: center;
`;
type Interface = { className?: string; onClick?: () => void };

export const Component = ({ className = '', onClick }: Interface): ReactElement => (
	<i className={className} onClick={onClick}>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.66667 5L2 7.66667M2 7.66667L4.66667 10.3333M2 7.66667L11.3333 7.66667C12.0406 7.66667 12.7189 7.94762 13.219 8.44772C13.719 8.94781 14 9.62609 14 10.3333V11.6667"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</i>
);

const ReplyIcon = styled(Component)(
	({
		theme: {
			chat: {
				replyMessage: {
					replyPreviewContainer: { replyIconColor, replyIconSize },
				},
			},
		},
	}: {
		theme: Theme;
	}) => {
		return {
			top: `calc(50% - ${typeof replyIconSize === 'number' ? replyIconSize / 2 : 8}px)`,
			'& svg': {
				width: replyIconSize,
				height: replyIconSize,
				stroke: replyIconColor,
			},
		};
	},
	styles
);

export { ReplyIcon };
